import React from 'react'
import { string } from 'prop-types'
import { MediaIframeEmbed } from '../MediaIframeEmbed'

export const Smashcast = ({ channel, ...rest }) => {
  if (!channel) return null
  return <MediaIframeEmbed src={`https://www.smashcast.tv/#!/embed/${channel}`} {...rest} />
}

Smashcast.propTypes = {
  channel: string,
}
